import { endDatePassedOrNull } from '@/helpers/index.js'

export const activities = {
  state: {
    filteredByCategory: {},
    items: [],
  },
  mutations: {
    setFilteredByCategory(state, categories) {
      categories.forEach(({ id }) => {
        state.filteredByCategory[id] = state.items.filter(({ category }) => category === id)
      })
    },
    setActivities(state, apiActivities) {
      let duplicatedActivities = []

      apiActivities.forEach((apiActivity) => {
        Object.values(apiActivity.groups).forEach((group) => {
          let activity = { ...apiActivity }
          activity['start_date'] = group.start_date
          activity['end_date'] = group.end_date
          activity['group_id'] = group.id
          activity['route'] = {
            name: 'activity',
            params: { slug: activity.slug },
            query: { g: group.id },
          }

          duplicatedActivities.push(activity)
        })
      })

      const sortedActivities = duplicatedActivities.toSorted(
        (activityA, activityB) => new Date(activityA.start_date) - new Date(activityB.end_date),
      )

      let [timelessActivities, upcomingActivities] = sortedActivities.reduce(
        ([p, f], activity) =>
          endDatePassedOrNull(activity.end_date) ? [[activity, ...p], f] : [p, [...f, activity]],
        [[], []],
      )

      timelessActivities.forEach((activity, index) => {
        upcomingActivities.splice(index * 3 + 2, 0, activity)
      })

      state.items = upcomingActivities
    },
  },
  actions: {
    setActivities(context, payload) {
      context.commit('setActivities', payload)
      context.commit('setFilteredByCategory', context.rootState.categories.items)
    },
  },
}
